import * as React from "react";
import {
  Card,
  CardContent,
  Typography,
  Stack,
  Chip,
  Button,
} from "@mui/material";
import QuestionRating from "./QuestionRating";
import {
  CheckCircle,
  CheckOutlined,
  ChevronRight,
  Unpublished,
  Visibility,
  WarningAmber,
} from "@mui/icons-material";
import { QuestionQuickViewDialog } from "./QuestionQuickViewDialog";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatUsageCount } from "../../../utils/formatters";
import { getQuestionTypeMeta } from "../utils";

function QuestionSummary({ question, onQuestionSelected, assignmentCreate }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  function getQuestionStatus(question) {
    if (question.isPublished) {
      return {
        label: "Published",
        icon: <CheckCircle />,
        color: "success",
      };
    }

    if (question.isComplete) {
      return {
        label: "Draft (Complete)",
        icon: <Unpublished />,
        color: "warning",
      };
    }

    return {
      label: "Draft (Incomplete)",
      icon: <WarningAmber />,
      color: "warning",
    };
  }

  const handleView = () => {
    if (assignmentCreate) {
      setOpen(true);
    } else {
      navigate(`/questions/view/${question.id}`);
    }
  };

  const status = getQuestionStatus(question);
  const typeMeta = getQuestionTypeMeta(question);

  const hasSchoolFramework = question?.schoolFeedbackFrameworks?.length > 0;

  return (
    <Card
      variant={"background"}
      data-testid={`question-summary-${question.id}`}
    >
      <QuestionQuickViewDialog
        question={question}
        open={open}
        setOpen={setOpen}
      />
      <CardContent>
        <Stack
          direction={"row"}
          spacing={2}
          justifyContent={"space-between"}
          alignContent={"center"}
          sx={{ mb: 2 }}
        >
          <Stack direction={"row"} spacing={1}>
            <Chip
              size={"medium"}
              label={typeMeta.label}
              variant="outlined"
              icon={typeMeta.icon}
              color={"primary"}
            />
            <Chip
              size={"medium"}
              label={status.label}
              color={status.color}
              variant="outlined"
              icon={status.icon}
            />
            {hasSchoolFramework && (
              <Chip
                size={"medium"}
                label={"School Framework"}
                color={"primary"}
                variant="outlined"
                icon={<CheckOutlined />}
              />
            )}
          </Stack>

          <QuestionRating question={question} disableAdd />
        </Stack>

        <Typography variant="subtitle1">{question.questionText}</Typography>
        <Stack direction={"row"} spacing={2} sx={{ mt: 1, mb: 2 }}>
          <Typography variant={"subtitle2"}>Tags: </Typography>
          {question.tags.map((tag) => (
            <Chip label={tag.tag} key={tag.id} sx={{ mt: 1, mb: 1 }} />
          ))}
        </Stack>
        <Stack
          direction={"row"}
          spacing={1}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{ mb: 1 }}
        >
          <Typography variant="subtitle2">
            {formatUsageCount(question.popularity)}
          </Typography>{" "}
          <Stack direction={"row"} spacing={2}>
            <Button
              variant={"outlined"}
              startIcon={<Visibility />}
              onClick={handleView}
            >
              View
            </Button>
            {assignmentCreate && (
              <Button
                variant={"contained"}
                endIcon={<ChevronRight />}
                onClick={() => onQuestionSelected(question)}
              >
                Select
              </Button>
            )}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default QuestionSummary;
